var _circle, _ellipse, _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSettingsClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 327.20001,
    viewBox: "0 0 327.20001 327.20001",
    width: 327.20001,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 163.60001,
    cy: 157.31001,
    fill: "#8c9aff",
    r: 157.3
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 163.60001,
    cy: 157.31001,
    fill: "#bac2ff",
    rx: 138.42999,
    ry: 157.3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m25.17 157.31c0-86.88 62-157.31 138.43-157.31a157.31 157.31 0 0 0 0 314.6c-76.45 0-138.43-70.42-138.43-157.29z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#27227d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m163.6 327.2a163.6 163.6 0 1 1 163.6-163.6 163.6 163.6 0 0 1 -163.6 163.6zm0-314.6a151 151 0 1 0 151 151 151 151 0 0 0 -151-151z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106.97 226.52a6.29 6.29 0 0 1 -4.45-10.74l113.26-113.26a6.2932504 6.2932504 0 1 1 8.9 8.9l-113.26 113.26a6.29 6.29 0 0 1 -4.45 1.84z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m220.23 226.52a6.29 6.29 0 0 1 -4.45-1.84l-113.26-113.26a6.2932504 6.2932504 0 0 1 8.9-8.9l113.26 113.26a6.29 6.29 0 0 1 -4.45 10.74z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsClose);
export default __webpack_public_path__ + "static/media/settingsClose.8ba955f7e84882551700e346867a3894.svg";
export { ForwardRef as ReactComponent };